export default __webpack_public_path__ + "static/media/ico_icu_gray.b590fa4a.svg";